module.exports = __webpack_public_path__ + "static/media/open-chest.19efe783.mp3";